<template>
  <div class="form-group">
    <label for="inputId" aria-label="Explanation" class="form-label">
      {{ label }}
      <span v-if="$props.required && $props.label" class="required"></span>
      <span v-if="optionalLabel" class="optional-label">({{ optionalLabel }})</span>
    </label>
    <div :class="[
      `form-input`,
      error && `form-input--error`,
    ]"
    >
      <textarea
        id="textArea"
        autocorrect="off"
        autocapitalize="none"
        spellcheck="false"
        :placeholder="placeholder"
        :class="[`form-input__field`, hover && `hover`, focus && `focus`]"
        :disabled="disabled"
        :value="value"
        :max-length="maxLength"
        @input="$emit('onChange', $event.target.value)"
      ></textarea>
    </div>
    <p
      v-if="errorMessage"
      class="form-label form-label--error form-label--error--active"
    >{{ errorMessage }}</p>
    <div
      v-if="helpMessage"
      :class="[`form-help`, helpMessagePosition === `right` && `text-right`]"
    >{{ helpMessage }}</div>
  </div>
</template>

<script>
export default {
  name: "TextArea",
  props: {
    /**
     * @description
     * Provides Label for Text Area
     */
    label: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Provides Error Message for Text Area
     */
    errorMessage: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Provides Help Message for Text Area
     */
    helpMessage: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Provides Placeholder for Text Area
     */
    placeholder: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Provides Optional Label for Text Area
     */
    optionalLabel: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Emits the value change on Text Area, Parent Component needs to sync values emitted
     */
    value: {
      type: String,
      required: true,
    },
    /**
     * @description
     * Checks the Text Area help message position
     * Maersk Design System supports left and right
     */
    helpMessagePosition: {
      type: String,
      validator: (val) => ["left", "right"].includes(val),
      default: "left",
    },
    /**
     * @description
     * Checks if the Text Area should be Disabled
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Text Area should be Hoverable
     */
    hover: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Text Area should be Focusable
     */
    focus: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Text Area should display Error Outline
     */
    error: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Text Area should display as Required
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Provide max length user can type in Text Area
     */
    maxLength: {
      type: String,
      default: ""
    }
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  .required:after {
    content: " *";
    color: red;
  }
}
</style>